import store from "@/store";

const linguagem = 'br';

const opcoes = {
  numeric: null,
  sensitivity: 'base',
};

function definirOrdenacaoNumerica(chave, itens) {
  opcoes.numeric = !itens.some(item => isNaN(item[chave]));
}

export function ordenarColuna(a, b, rules, itens) {
  const chave = rules.order ? rules.value : store.getters["tabela_compra/getColunaOrdenacaoPadrao"];

  definirOrdenacaoNumerica(chave, itens);

  if (!rules.order || rules.order === 'up') {
    return !opcoes.numeric
      ? `${a[chave]}`.localeCompare(`${b[chave]}`, linguagem, opcoes)
      : a[chave] - b[chave];
  }

  return !opcoes.numeric
    ? `${b[chave]}`.localeCompare(`${a[chave]}`, linguagem, opcoes)
    : b[chave] - a[chave];
}

export function ordenarColunasCombinadas(a, b, rules, itens) {
  const coluna = store.getters["tabela_compra/getColunasEmOrdenacaoCombinada"]
    .find(coluna => a[coluna.value] !== b[coluna.value]);

  if (!coluna) return 0;

  definirOrdenacaoNumerica(rules.value, itens);

  let ordenar_do_menor_para_maior = coluna.order === 'up';

  if (coluna.inverter_ordenacao) {
    ordenar_do_menor_para_maior = !ordenar_do_menor_para_maior;
  }

  if (ordenar_do_menor_para_maior) {
    return !opcoes.numeric
      ? `${a[coluna.value]}`.localeCompare(`${b[coluna.value]}`, linguagem, opcoes)
      : a[coluna.value] - b[coluna.value];
  }

  return !opcoes.numeric
    ? `${b[coluna.value]}`.localeCompare(`${a[coluna.value]}`, linguagem, opcoes)
    : b[coluna.value] - a[coluna.value];
}
